import { Injectable, Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

// TODO(js): Make configurable
@Injectable({
  providedIn: 'root',
})
export class TranslateLangService {
  private static readonly DEFAULT_LANGUAGE = 'de-DE';

  public constructor(private injector: Injector, private translate: TranslateService) {}

  public async load(): Promise<void> {
    try {
      await this.injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

      /*
       * const browserLang = navigator.language;
       * const defaultLang = browserLang.match(/en-US|de-DE/) ? browserLang : TranslateLangService.DEFAULT_LANGUAGE;
       */
      const defaultLang = TranslateLangService.DEFAULT_LANGUAGE;

      this.translate.setDefaultLang(defaultLang);
      await this.translate.use(defaultLang).toPromise();
    } catch (error) {
      throw new Error('Failed to initialize language.');
    }
  }
}
